import LeaveRequestCard from "./LeaveRequestCard";
import { useLeavesById } from "./hooks/useLeavesById";

interface LeaveRequestHistoryProps {
  employeeId: number;
}

const LeaveRequestHistory = ({ employeeId }: LeaveRequestHistoryProps) => {
  const { data: leaves = [], isLoading } = useLeavesById({ employeeId });

  if(isLoading) {
    return (
      <div className="pt-12">
        <div className="p-16 flex items-center justify-center">
          <span className="loading loading-ring loading-lg"></span>
        </div>
      </div>
    );
  };

  return (
    <div className="pt-6">
      {
        leaves?.length === 0 && (
          <div className="w-full">
            <p className="text-sm text-muted font-semibold text-center">No Leave Requests</p>
          </div>
        )
      }
        <div className="grid grid-cols-2 gap-6">
          {leaves.length > 0 && (
            leaves.map((leave) => (
              <LeaveRequestCard leave={leave} key={leave.id} />
            ))
          )}
        </div>
    </div>
  );
};

export default LeaveRequestHistory;
